//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ÑÐ¼',
        1: '-ÑÐ¼',
        2: '-ÑÐ¼',
        3: '-ÑÐ¼',
        4: '-ÑÐ¼',
        5: '-ÑÐ¼',
        6: '-ÑÐ¼',
        7: '-ÑÐ¼',
        8: '-ÑÐ¼',
        9: '-ÑÐ¼',
        10: '-ÑÐ¼',
        12: '-ÑÐ¼',
        13: '-ÑÐ¼',
        20: '-ÑÐ¼',
        30: '-ÑÐ¼',
        40: '-ÑÐ¼',
        50: '-ÑÐ¼',
        60: '-ÑÐ¼',
        70: '-ÑÐ¼',
        80: '-ÑÐ¼',
        90: '-ÑÐ¼',
        100: '-ÑÐ¼',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'ÑÐ½Ð²Ð°ÑÐ¸_ÑÐµÐ²ÑÐ°Ð»Ð¸_Ð¼Ð°ÑÑÐ¸_Ð°Ð¿ÑÐµÐ»Ð¸_Ð¼Ð°Ð¹Ð¸_Ð¸ÑÐ½Ð¸_Ð¸ÑÐ»Ð¸_Ð°Ð²Ð³ÑÑÑÐ¸_ÑÐµÐ½ÑÑÐ±ÑÐ¸_Ð¾ÐºÑÑÐ±ÑÐ¸_Ð½Ð¾ÑÐ±ÑÐ¸_Ð´ÐµÐºÐ°Ð±ÑÐ¸'.split(
                '_'
            ),
            standalone:
                'ÑÐ½Ð²Ð°Ñ_ÑÐµÐ²ÑÐ°Ð»_Ð¼Ð°ÑÑ_Ð°Ð¿ÑÐµÐ»_Ð¼Ð°Ð¹_Ð¸ÑÐ½_Ð¸ÑÐ»_Ð°Ð²Ð³ÑÑÑ_ÑÐµÐ½ÑÑÐ±Ñ_Ð¾ÐºÑÑÐ±Ñ_Ð½Ð¾ÑÐ±Ñ_Ð´ÐµÐºÐ°Ð±Ñ'.split(
                    '_'
                ),
        },
        monthsShort: 'ÑÐ½Ð²_ÑÐµÐ²_Ð¼Ð°Ñ_Ð°Ð¿Ñ_Ð¼Ð°Ð¹_Ð¸ÑÐ½_Ð¸ÑÐ»_Ð°Ð²Ð³_ÑÐµÐ½_Ð¾ÐºÑ_Ð½Ð¾Ñ_Ð´ÐµÐº'.split('_'),
        weekdays: 'ÑÐºÑÐ°Ð½Ð±Ðµ_Ð´ÑÑÐ°Ð½Ð±Ðµ_ÑÐµÑÐ°Ð½Ð±Ðµ_ÑÐ¾ÑÑÐ°Ð½Ð±Ðµ_Ð¿Ð°Ð½Ò·ÑÐ°Ð½Ð±Ðµ_Ò·ÑÐ¼ÑÐ°_ÑÐ°Ð½Ð±Ðµ'.split(
            '_'
        ),
        weekdaysShort: 'ÑÑÐ±_Ð´ÑÐ±_ÑÑÐ±_ÑÑÐ±_Ð¿ÑÐ±_Ò·ÑÐ¼_ÑÐ½Ð±'.split('_'),
        weekdaysMin: 'ÑÑ_Ð´Ñ_ÑÑ_ÑÑ_Ð¿Ñ_Ò·Ð¼_ÑÐ±'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ÐÐ¼ÑÓ¯Ð· ÑÐ¾Ð°ÑÐ¸] LT',
            nextDay: '[Ð¤Ð°ÑÐ´Ð¾ ÑÐ¾Ð°ÑÐ¸] LT',
            lastDay: '[ÐÐ¸ÑÓ¯Ð· ÑÐ¾Ð°ÑÐ¸] LT',
            nextWeek: 'dddd[Ð¸] [Ò³Ð°ÑÑÐ°Ð¸ Ð¾ÑÐ½Ð´Ð° ÑÐ¾Ð°ÑÐ¸] LT',
            lastWeek: 'dddd[Ð¸] [Ò³Ð°ÑÑÐ°Ð¸ Ð³ÑÐ·Ð°ÑÑÐ° ÑÐ¾Ð°ÑÐ¸] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Ð±Ð°ÑÐ´Ð¸ %s',
            past: '%s Ð¿ÐµÑ',
            s: 'ÑÐºÑÐ°Ð½Ð´ ÑÐ¾Ð½Ð¸Ñ',
            m: 'ÑÐº Ð´Ð°ÒÐ¸ÒÐ°',
            mm: '%d Ð´Ð°ÒÐ¸ÒÐ°',
            h: 'ÑÐº ÑÐ¾Ð°Ñ',
            hh: '%d ÑÐ¾Ð°Ñ',
            d: 'ÑÐº ÑÓ¯Ð·',
            dd: '%d ÑÓ¯Ð·',
            M: 'ÑÐº Ð¼Ð¾Ò³',
            MM: '%d Ð¼Ð¾Ò³',
            y: 'ÑÐº ÑÐ¾Ð»',
            yy: '%d ÑÐ¾Ð»',
        },
        meridiemParse: /ÑÐ°Ð±|ÑÑÐ±Ò³|ÑÓ¯Ð·|Ð±ÐµÐ³Ð¾Ò³/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ÑÐ°Ð±') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ÑÑÐ±Ò³') {
                return hour;
            } else if (meridiem === 'ÑÓ¯Ð·') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'Ð±ÐµÐ³Ð¾Ò³') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ÑÐ°Ð±';
            } else if (hour < 11) {
                return 'ÑÑÐ±Ò³';
            } else if (hour < 16) {
                return 'ÑÓ¯Ð·';
            } else if (hour < 19) {
                return 'Ð±ÐµÐ³Ð¾Ò³';
            } else {
                return 'ÑÐ°Ð±';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ÑÐ¼|ÑÐ¼)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));
